import { IBreastCancerPRS, IFetchBreastCancerPRSParams } from '~/interfaces'
import { AxiosResponse, axios } from '~/modules'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchBreastCancerPRS = async (params: IFetchBreastCancerPRSParams): Promise<IBreastCancerPRS> => {
  const { pathParams } = params
  const response = await axios.get(`${hstoryAPI}/patients/${pathParams.patientId}/breast-cancer-prs`)
  const { data }: AxiosResponse<IBreastCancerPRS> = response
  return data
}
